/**
 * Maps documentation route paths to content.
 * Paths match the TOC structure (e.g. 1-introduction, 2-1-1-overview).
 */
import { content } from "./fullContent";
import { content2 } from "./fullContent2";
import { content3 } from "./fullContent3";
import { content4 } from "./fullContent4";

const CONTENT_MAP = {
  ...content,
  ...content2,
  ...content3,
  ...content4,
};

export default CONTENT_MAP;
